"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reducer = _interopRequireDefault(require("settings-ui-sdk/AdsAccounts/reducer"));

var _reducer2 = _interopRequireDefault(require("settings-ui-sdk/AdsPixel/reducer"));

var _reducer3 = _interopRequireDefault(require("settings-ui-sdk/AdsROI/reducer"));

var _redux = require("redux");

var _default = (0, _redux.combineReducers)({
  accounts: _reducer.default,
  pixelSettings: _reducer2.default,
  roiSettings: _reducer3.default
});

exports.default = _default;
module.exports = exports.default;